module.exports = __webpack_public_path__ + "img/tag2.f24a7118.png";